'use client'
import * as React from 'react'
import { useTranslations } from 'next-intl'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { Link } from '@repo/web-ui/components/link'
import { useHasActiveSubscription } from '@repo/cf-user/contexts/auth'

import { CommercialLicenseIcon } from '@web/components/icons/commercial-license'
import { ProductHighlight } from './product-highlight/product-hightlight'

export function CommercialLicenseLink() {
  const t = useTranslations('prod.product_description_page.buy.license')
  const hasActiveSubscription = useHasActiveSubscription()

  if (!hasActiveSubscription) {
    return null
  }

  return (
    <ProductHighlight>
      <CommercialLicenseIcon className="size-5 shrink-0" />
      <span className="inline-block py-1">
        {t.rich('label_commercial', {
          b: str => <b className="font-bold">{str}</b>,
          link: str => (
            <Link
              tabIndex={0}
              className="text-cf-link cursor-pointer whitespace-nowrap underline hover:no-underline"
              href={AppRoutes.COMMERCIAL_USE_GUIDE}
              rel="noreferrer"
              target="_blank"
            >
              {str}
            </Link>
          ),
        })}
      </span>
    </ProductHighlight>
  )
}
